<template>
    <div class="related_block">
        <h3 class="font-active">Related stories</h3>
        <div class="row">
            <div class="col-lg-3 col-md-4 mb-3" v-for="item in data" :key="item.id">
                <div class="related_box">
                    <router-link :to="localePath('/blog/'+item.slug)">
                        <img class="radious_eight" height="552" width="430" :alt="item.title" :src="item.image" />
                        <h4 class="font-active">{{ item.title }}</h4>
                        <h6>{{ item.short_desc }}</h6>
                        <p>Posted under <span class="radious_eight">{{ item.category_name }}</span></p>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { data } = defineProps(['data'])
   
</script>

<style scoped>
h3 {
    text-align: center;
    font-size: 38px;
    margin: 6% 0 4% 0;
}

.related_box a {
    color: #000;
}

.related_box h4 {
    font-size: 20px;
    padding: 24px 0 0 0;
}

.related_box h6 {
    color: #606060;
    margin-bottom: 22px;
}

.related_box p {
    font-size: 14px;
    font-weight: 500;
}

.related_box p span {
    text-transform: uppercase;
    font-weight: 600;
    border: 1px solid #000;
    padding: 3px 10px;
    margin-left: 10px;
    display: inline-block;
}

@media(max-width: 1250px){
    h3{
        font-size: 36px;
    }
    .related_box h4{
        font-size: 20px;
    }
    .related_box p span{
        margin-left: 0;
        margin-top: 10px;
    }
}

@media(max-width: 767px){
    .related_box p span{
        margin-left: 0;
        margin-top: 10px;
    }
    h3{
        font-size: 26px;
        margin-bottom: 30px;
    }
    .related_box h6 {
        line-height: 22px;
    }
    .related_box h6{
        margin-bottom: 0;
    }
}
</style>
